import { render, staticRenderFns } from "./ErrorPageLayout.vue?vue&type=template&id=f8109aa8&"
import script from "./ErrorPageLayout.vue?vue&type=script&lang=js&"
export * from "./ErrorPageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports